import { isAfter } from 'date-fns/esm'
import { ActivityStatus } from '@user/features/Activity/constants'
import type { ActivityDetails } from '@user/features/Activity/typings'

export class ActivitiesHelper {
  static isOverdueActivity(activity: ActivityDetails) {
    return (
      isAfter(new Date(), new Date(activity.dueDate)) &&
      (activity.status === ActivityStatus.Todo ||
        activity.status === ActivityStatus.InProgress)
    )
  }
}
